import { ArrowRight } from 'lucide-react'
import type { LandingPersona } from '@/hooks/useLandingPersona'

interface Props {
  persona: LandingPersona
  onCta: () => void
  onSignIn: () => void
}

export default function LandingCTA({ persona, onCta, onSignIn }: Props) {
  return (
    <section className="lp-section" style={{ paddingTop: 0 }}>
      <div className="lp-container">
        <div className="lp-cta">
          <div className="lp-eyebrow" style={{ marginBottom: 22, justifyContent: 'center' }}>
            One last thing
          </div>
          <h2>
            Stop running the business. <br />
            <span style={{ color: persona.primary, textShadow: `0 0 60px ${persona.glow}` }}>
              Start building it.
            </span>
          </h2>
          <p>
            Two days a week, every week, go back to the work only you can do. Your AI is
            live the moment you sign up — phone number provisioned, agent online, first
            briefing already scheduled.
          </p>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: 12,
              flexWrap: 'wrap',
            }}
          >
            <button className="lp-btn-primary" onClick={onCta}>
              {persona.cta} <ArrowRight size={16} />
            </button>
            <button className="lp-btn-outline" onClick={onSignIn}>
              I already have an account
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
